export default (elem, offset) => {
    if (!document.querySelector(elem)) {
        return false;
    }
    const height = document.querySelector(elem).offsetTop + document.querySelector(elem).offsetParent.offsetTop;
    window.scrollTo(0, height - offset);
    return true;
};
